import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from "react-redux";
import {
    IAppState, ICenterNotificationListResponse, IApplicationState, CenterNotificationActionCreators, AppActionCreators,
    CenterActionCreators, ICenterNotificationCreateResponse, IBasicCenterListResponse, INotificationLookupDataResponse
} from '@nkr/store/index';
import { ICenterNotification, ICenterBase, IBaseResponse, INotificationType } from '@nkr/models/index';
import { GridWrapper } from './styles';
import { GridApi, GridReadyEvent, CsvExportParams, ProcessCellForExportParams } from 'ag-grid-community';
import { FormControl, Button } from 'react-bootstrap';
import AddEdit from './add-edit';
import Drawer from 'rc-drawer';
import Delete from './delete';
import { ItemActions } from './item-actions';
import Grid from './grid';

interface IOwnProps { }

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getCenterNotifications: (centerId: number) => Promise<ICenterNotificationListResponse>,
    getBasicCenterList: () => Promise<IBasicCenterListResponse>,
    getNotificationLookupData: () => Promise<INotificationLookupDataResponse>,
    createCenterNotification: (centerId: number, description: string, content: string, notificationTypeId: number, isEnabled: boolean) => Promise<ICenterNotificationCreateResponse>,
    updateCenterNotification: (id: number, centerId: number, description: string, content: string, notificationTypeId: number, isEnabled: boolean) => Promise<IBaseResponse>,
    deleteNotification: (id: number) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    list: ICenterNotification[],
    centerList: ICenterBase[],
    notificationTypeList: INotificationType[],
    center: number,
    addEdit: {
        show: boolean,
        isClone: boolean,
        data: ICenterNotification | null
    },
    delete: {
        show: boolean,
        id: number,
        description: string
    },
    gridApi: GridApi
}

class CenterNotifications extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        centerList: [],
        notificationTypeList: [],
        center: 0,
        addEdit: {
            show: false,
            isClone: false,
            data: null
        },
        delete: {
            show: false,
            id: 0,
            description: ''
        },
        gridApi: null
    }

    container: HTMLDivElement;
    acknowledgmentTimer: any;

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api
        });

        e.api.sizeColumnsToFit();
    }

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    componentDidMount = () => {
        this.getData();
    }

    handleCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            center: parseInt(e.currentTarget.value)
        });
    }

    handleActionSelection = (action: ItemActions, id: number) => {
        let data = this.state.list.find(x => x.id == id);

        if (action == ItemActions.Edit) {
            this.setState({
                addEdit: {
                    show: true,
                    isClone: false,
                    data
                }
            });
        }

        if (action == ItemActions.Delete) {
            this.setState({
                delete: {
                    show: true,
                    id: data != null ? data.id : 0,
                    description: data != null ? data.description : ''
                }
            });
        }

        if (action == ItemActions.Clone) {
            this.setState({
                addEdit: {
                    show: true,
                    isClone: true,
                    data: { ..._.cloneDeep(data), id: 0 }
                }
            });
        }
    }

    handleAddNotification = () => {
        this.setState({
            addEdit: { show: true, isClone: false, data: null }
        });
    }

    handleCancelAddEditNotification = () => {
        this.setState({
            addEdit: { ...this.state.addEdit, show: false }
        });
    }

    handleSaveAddEditNotification = (id: number, center: number, description: string, content: string, notificationTypeId: number, isEnabled: boolean) => {
        this.setState({
            addEdit: { ...this.state.addEdit, show: false }
        }, () => {
            if (id == 0) {
                this.createNotification(center, description, content, notificationTypeId, isEnabled);
            } else {
                this.updateNotification(id, center, description, content, notificationTypeId, isEnabled);
            }
        });
    }

    handleDelete = () => {
        let { id } = this.state.delete;

        this.setState({
            delete: {
                show: false,
                id: 0,
                description: ''
            }
        }, () => {
            this.deleteNotification(id);
        });
    }

    handleCancelDelete = () => {
        this.setState({
            delete: {
                show: false,
                id: 0,
                description: ''
            }
        });
    }

    getData = () => {
        this.props.showLoading("Loading notifications, one moment please...").then(() => {
            return Promise
                .all([
                    this.props.getCenterNotifications(this.state.center),
                    this.props.getBasicCenterList(),
                    this.props.getNotificationLookupData()
                ])
                .then(([centerListResponse, basicCenterListResponse, notificationLookupDataResponse]) => {
                    this.props.hideLoading();

                    this.acknowledgmentTimer = window.setInterval(this.checkForAcknowledgments, 2000);

                    this.setState({
                        list: centerListResponse.data.results,
                        centerList: basicCenterListResponse.data.results.map(c => {
                            return { id: c.id, alias: c.alias, name: c.name, isMemberCenter: c.isMemberCenter, centerAddresses: [] };
                        }),
                        notificationTypeList: notificationLookupDataResponse.data.results
                    })
                });
        });
    }

    createNotification = (center: number, description: string, content: string, notificationTypeId: number, isEnabled: boolean) => {
        this.props.showLoading('Creating center notification, one moment please...').then(() => {
            this.props.createCenterNotification(center, description, content, notificationTypeId, isEnabled).then((response) => {
                let list = _.cloneDeep(this.state.list);

                let ctr = this.state.centerList.find(x => x.id == center);

                list.push({ id: response.data.results.id, centerId: center, centerAlias: ctr.alias, description, notificationText: content, notificationTypeId: notificationTypeId, addedDateTime: response.data.results.addedDateTime, isEnabled, isRead: false, readDateTime: '', readByUserId: 0, readByUser: '' });

                this.setState({
                    list
                });

                this.props.hideLoading();
            });
        });
    }

    updateNotification = (id: number, center: number, description: string, content: string, notificationTypeId: number, isEnabled: boolean) => {
        this.props.showLoading('Updating center notification, one moment please...').then(() => {
            this.props.updateCenterNotification(id, center, description, content, notificationTypeId, isEnabled).then((response) => {
                let ctr = this.state.centerList.find(x => x.id == center);

                let list = _.cloneDeep(this.state.list).map(item => {
                    if (item.id == id) {
                        item.centerId = center;
                        item.centerAlias = ctr.alias;
                        item.description = description;
                        item.notificationText = content;
                        item.isEnabled = isEnabled;
                        item.notificationTypeId = notificationTypeId;
                    }

                    return item;
                });

                this.setState({
                    list
                });

                this.props.hideLoading();
            });
        });
    }

    deleteNotification = (id: number) => {
        this.props.showLoading('Deleting center notification, one moment please...').then(() => {
            this.props.deleteNotification(id).then((response) => {
                let list = _.cloneDeep(this.state.list).filter(x => {
                    return x.id != id;
                })

                this.setState({
                    list
                });

                this.props.hideLoading();
            });
        });
    }

    checkForAcknowledgments = () => {
        window.clearInterval(this.acknowledgmentTimer);

        this.props.getCenterNotifications(this.state.center).then(response => {
            this.setState({
                list: response.data.results
            });

            this.acknowledgmentTimer = window.setInterval(this.checkForAcknowledgments, 60000);
        });
    }


    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'center-notifications.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {

                return params.value;
            }
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        const filteredRows = this.state.center > 0 ? this.state.list.filter(x => x.centerId == this.state.center) : this.state.list;

        return (
            <>
                <div ref={this.saveContainer} />
                
                <div className="container">
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: 30, marginBottom: 20 }}>
                        <div style={{ flexBasis: "33%", fontSize: 28, fontWeight: 500 }}>
                            Center Notifications
                        </div>
                        <div>
                            <Button bsStyle='link' onClick={this.handleAddNotification}>Add Notification</Button>
                        </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: 30, marginBottom: 20 }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ marginRight: 5 }}>Center:</div>
                            <div>
                                <FormControl
                                    componentClass='select'
                                    value={this.state.center}
                                    onChange={this.handleCenterChange}
                                >
                                    <option value={0}>- ALL CENTERS -</option>
                                    {this.state.centerList.filter(x => x.isMemberCenter).map((center, index) =>
                                        <option key={`center-${index}`} value={center.id}>{center.alias}</option>
                                    )}
                                </FormControl>
                            </div>
                        </div>

                        <div style={{ marginRight: 5, float: 'right', display: 'flex' }}>
                            <Button bsStyle='primary' onClick={this.handleExport}>Export CSV</Button>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <GridWrapper className='ag-theme-bootstrap'>
                                <Grid data={filteredRows} onGridReady={this.onGridReady} onAction={this.handleActionSelection} />
                            </GridWrapper>
                        </div>
                    </div>
                </div>

                <Drawer
                    width="25vw"
                    // handler={false}
                    placement="right"
                    getContainer={this.getContainer}
                    open={this.state.addEdit.show}
                >
                    {this.state.addEdit.show && (
                        <AddEdit
                            data={this.state.addEdit.data}
                            clone={
                                {
                                    isClone: this.state.addEdit.isClone,
                                    description: this.state.addEdit.data != null ? _.cloneDeep(this.state.addEdit.data).description : ''
                                }
                            }
                            show={this.state.addEdit.show}
                            centerList={this.state.centerList}
                            notificationList={this.state.notificationTypeList}
                            onSave={this.handleSaveAddEditNotification}
                            onCancel={this.handleCancelAddEditNotification}
                        />
                    )}
                </Drawer>

                <Delete
                    show={this.state.delete.show}
                    description={this.state.delete.description}
                    onDelete={this.handleDelete}
                    onCancel={this.handleCancelDelete}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getCenterNotifications: (centerId) => { return dispatch(CenterNotificationActionCreators.getCenterNotifications(centerId)); },
        getBasicCenterList: () => { return dispatch(CenterActionCreators.getBasicCenterList(false)); },
        getNotificationLookupData: () => { return dispatch(CenterNotificationActionCreators.getNotificationLookupData()); },
        createCenterNotification: (centerId, description, content, notificationTypeId, isEnabled) => { return dispatch(CenterNotificationActionCreators.createCenterNotification(centerId, description, content, notificationTypeId, isEnabled)); },
        updateCenterNotification: (id, centerId, description, content, notificationTypeId, isEnabled) => { return dispatch(CenterNotificationActionCreators.updateCenterNotification(id, centerId, description, content, notificationTypeId, isEnabled)); },
        deleteNotification: (id) => { return dispatch(CenterNotificationActionCreators.deleteNotification(id)); }
    }
};

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterNotifications);